// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2sBDQ","requiredAsterisk":"Info_requiredAsterisk__2Oywd"};